import React from 'react';

const TempleCommittee = () => (
  <div id="committee" className="max-w-4xl mx-auto mt-12">
    <div className="card-temple">
      <h3 className="text-2xl font-bold text-saffron mb-6 text-center">
        Temple Committee
      </h3>
      
      <div className="text-center py-8">
        <div className="space-y-2">
          <p className="text-lg text-gray-700 font-semibold">
            P. S. Sudhakara Mallan - PRESIDENT
          </p>
          <p className="text-lg text-gray-700 font-semibold">
            K. R. Vijayagopal Shenoi - SECRETARY
          </p>
          <p className="text-lg text-gray-700 font-semibold">
            M. N. Madana Shenoi
          </p>
          <p className="text-lg text-gray-700 font-semibold">
            K. A. Venkateshwara Prabhu
          </p>
          <p className="text-lg text-gray-700 font-semibold">
            Vipin V. Pai
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default TempleCommittee;
